'use client';

import { c as _c } from "react/compiler-runtime";
import { type UseQueryResult, useQuery } from '@morfi/backend-sdk-v2/client';
const SHARE_FIELD_SVG_SRC = {
  telegram: '/images/support-mainnet/share/telegram-field.svg',
  x: '/images/support-mainnet/share/x-field.svg'
} as const;
export type ShareChannelFieldId = keyof typeof SHARE_FIELD_SVG_SRC;
async function fetchShareFieldSvg(src: string): Promise<string> {
  const response = await fetch(src);
  if (!response.ok) {
    throw new Error(`${src} fetch failed: ${response.status}`);
  }
  const svgMarkup = await response.text();
  const trimmed = svgMarkup.trimStart();
  if (!trimmed.startsWith('<svg')) {
    throw new Error(`${src} response is not SVG markup`);
  }
  return trimmed;
}
export function useShareChannelFieldSvg(channel) {
  const $ = _c(2);
  let t0;
  if ($[0] !== channel) {
    t0 = {
      queryKey: ["share-channel-field", channel],
      queryFn: () => fetchShareFieldSvg(SHARE_FIELD_SVG_SRC[channel]),
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: Number.POSITIVE_INFINITY,
      retry: false
    };
    $[0] = channel;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}